import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { removeEntity } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useRemoveEntity({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ entityId }) => removeEntity(entityId),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Entity Removed Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing Entity");
        },
    });
}
